module.exports = __webpack_public_path__ + "static/media/biteship-tokopedia.4a051138.png";